import { Component } from '@angular/core';
import { TaiaoDashboardLayoutComponentBase } from '../../../classes/taiao-dashboard-layout-component.class';
import * as ChartConfig from './charts.config';
@Component({
  selector: 'app-client-taiao-dashboard-layout',
  templateUrl: './taiao-dashboard-layout.component.html',
  styleUrls: ['./taiao-dashboard-layout.component.scss'],
})
export class wastemanagement_TaiaoDashboardLayoutComponent extends TaiaoDashboardLayoutComponentBase {
  ChartConfig = ChartConfig;
}
